// router title 国际化
export function generateTitle(title) {
  //  检查 key 是否存在
  const hasKey = this.$te('route.' + title)
  if (hasKey) {
    const translatedTitle = this.$t('route.' + title)
    return translatedTitle
  }
  return title
}

export function checkLang(query) {
  var reg = /^[\u4E00-\u9FA5]+$/
  return reg.test(query) ? 'zh-CN' : 'en'
}
